/*
 * Google OAuth 弹窗状态桥接，更新时间：2026-09-04 17:45 CST。
 *
 * 游客登录弹窗和 OAuth 回调运行在两个同源窗口，sessionStorage 不共享。
 * 这里只在 localStorage 暂存随机 state，回调最多消费一次且 10 分钟后失效；
 * 不保存授权码、令牌或用户资料，禁止把此校验降级为“有 state 即通过”。
 */
export const GOOGLE_POPUP_STATE_PREFIX = 'hotx-cdn:console:google-popup-state:';
// 来源：console-google-popup-return-20260915；CST 2026-09-15 17:46；父基线 c79cc29664c6b69410189f64679c7762310e252c。
// 仅用作同源弹窗的完成通知类型，真正的授权仍由后端换取 token 并由一次性 state 校验约束。
export const GOOGLE_POPUP_AUTHENTICATED_MESSAGE_TYPE = 'hotx:console:google-popup-authenticated';
const GOOGLE_POPUP_STATE_MAX_AGE_MS = 10 * 60 * 1000;

export function saveGooglePopupState(state: string) {
  const storage = browserStorage();
  if (!storage || !state) return;
  removeExpiredGooglePopupStates(storage);
  storage.setItem(`${GOOGLE_POPUP_STATE_PREFIX}${state}`, String(Date.now()));
}

export function consumeGooglePopupState(state?: string) {
  const storage = browserStorage();
  if (!storage || !state) return false;
  const key = `${GOOGLE_POPUP_STATE_PREFIX}${state}`;
  const savedAt = Number(storage.getItem(key));
  storage.removeItem(key);
  if (!Number.isFinite(savedAt) || savedAt <= 0) return false;
  const age = Date.now() - savedAt;
  return age >= -30_000 && age <= GOOGLE_POPUP_STATE_MAX_AGE_MS;
}

export function discardGooglePopupState(state?: string | null) {
  const storage = browserStorage();
  if (storage && state) storage.removeItem(`${GOOGLE_POPUP_STATE_PREFIX}${state}`);
}

function removeExpiredGooglePopupStates(storage: Storage) {
  const now = Date.now();
  for (let index = storage.length - 1; index >= 0; index -= 1) {
    const key = storage.key(index);
    if (!key?.startsWith(GOOGLE_POPUP_STATE_PREFIX)) continue;
    const savedAt = Number(storage.getItem(key));
    if (!Number.isFinite(savedAt) || now - savedAt > GOOGLE_POPUP_STATE_MAX_AGE_MS) {
      storage.removeItem(key);
    }
  }
}

function browserStorage() {
  return typeof window === 'undefined' ? null : window.localStorage;
}
